import moment from "moment";
import "moment-timezone";

export const getDateTimeNow = () => {
    return moment().tz("GMT").format("YYYY-MM-DDTHH:mm:ss.SSSSSS+00:00");
};
